import React from 'react';
import PropTypes from 'prop-types';
import {splitSsn} from 'utils/strings'


const TextRegno = ({ value, className }) => {   
    return (
        <span className={className} >{splitSsn(value)}</span>
      );
};

TextRegno.propTypes = {
  value: PropTypes.string,  
  className : PropTypes.string  
};

export default TextRegno;
